import { CallCopilotObjectionMessageI } from "@/lib/types/call-copilot/objection";
import { CallCopilotMessageContainer } from "@/modules/pipeline/account-details/sections/call-copilot-section/message-types/message-container";
import { Badge } from "shared/ui/shadcn/badge";
import { BanIcon, BotIcon } from "lucide-react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";

export const CallCopilotObjectionMessage = ({
  objection,
  objection_handle,
}: CallCopilotObjectionMessageI) => {
  return (
    <div className="mb-8">
      <CallCopilotMessageContainer>
        <div className="-mt-8 mb-1">
          <Badge className="mb-2 bg-[#FFA95A] text-black typography-body-4-medium">
            <BanIcon className="mr-1 h-4 w-4" /> Objection detected
          </Badge>
          <span className="text-black typography-body-4-medium">
            {objection && (
              <ReactMarkdown
                // components={{ p: CustomMarkdownParagraph }}
                remarkPlugins={[remarkGfm, remarkBreaks]}
              >
                {objection}
              </ReactMarkdown>
            )}
          </span>
        </div>
      </CallCopilotMessageContainer>

      <CallCopilotMessageContainer isConnected>
        <div className="-mt-8 mb-2 flex items-center gap-x-1">
          <Badge className="app-gradient-reverse typography-body-4-medium">
            <BotIcon className="mr-1 h-4 w-4" /> Copilot response
          </Badge>
        </div>

        {objection_handle && (
          <ReactMarkdown
            // components={{ p: CustomMarkdownParagraph }}
            className="text-black typography-body-4"
            remarkPlugins={[remarkGfm, remarkBreaks]}
          >
            {objection_handle}
          </ReactMarkdown>
        )}
      </CallCopilotMessageContainer>
    </div>
  );
};
